import {
  createRoot,
  createSignal,
  createMemo,
  Show,
} from "https://cdn.jsdelivr.net/npm/solid-js@1.9.5/+esm";
import { insert } from "https://cdn.jsdelivr.net/npm/solid-js@1.9.5/web/+esm";
import {
  register,
  compose,
  noShadowDOM,
} from "https://cdn.jsdelivr.net/npm/component-register/+esm";

import html from "https://cdn.jsdelivr.net/npm/solid-js@1.9.5/html/+esm";
import { getProductContext } from "https://cdn.jsdelivr.net/npm/@brytdesigns/shopify-product-info-components@1.0.6/+esm";

// Utility custom element functions

function createProps(raw) {
  const keys = Object.keys(raw);
  const props = {};
  for (let i = 0; i < keys.length; i++) {
    const [get, set] = createSignal(raw[keys[i]]);
    Object.defineProperty(props, keys[i], {
      get() {
        return get();
      },
      set(v) {
        set(() => v);
      },
    });
  }
  return props;
}

function lookupContext(el) {
  if (el.assignedSlot && el.assignedSlot._$owner)
    return el.assignedSlot._$owner;
  let next = el.parentNode;
  while (
    next &&
    !next._$owner &&
    !(next.assignedSlot && next.assignedSlot._$owner)
  )
    next = next.parentNode;
  return next && next.assignedSlot ? next.assignedSlot._$owner : el._$owner;
}

function withSolid(ComponentType) {
  return (rawProps, options) => {
    const { element } = options;
    return createRoot((dispose) => {
      const props = createProps(rawProps);
      element.addPropertyChangedCallback((key, val) => (props[key] = val));
      element.addReleaseCallback(() => {
        element.renderRoot.textContent = "";
        dispose();
      });
      const comp = ComponentType(props, options);
      return insert(element.renderRoot, comp);
    }, lookupContext(element));
  };
}

function withNoShadowDOM(Component) {
  return (props, options) => {
    noShadowDOM();
    const comp = Component(props, options);
    return comp;
  };
}

const customShadowlessElement = (
  tagName,
  props = {},
  Component = (props, options) => {},
  ...rest
) =>
  compose(
    register(tagName, props),
    withNoShadowDOM,
    withSolid,
    ...rest,
  )(Component);

customShadowlessElement(
  "variant-nutrition-images",
  { images: {} },
  (props, { element }) => {
    if (!props.images)
      return console.warn("variant-nutrition-images: No images provided");
    const productInfo = element.closest("product-info");
    if (!productInfo)
      return console.warn(
        "variant-nutrition-images: No product-info parent element found",
      );
    const [state, _] = getProductContext(productInfo);

    const imagesHTML = createMemo(() => {
      const variantId = state.product.selected_or_first_available_variant.id;
      return props.images[variantId];
    });

    const childrenFallback = Array.from(element.children);

    element.replaceChildren(...[]);
    return html`
      <${Show} when=${imagesHTML} fallback=${() => childrenFallback}>
        <div innerHTML=${imagesHTML} />
      <//>
    `;
  },
);
